/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import { Component } from '@angular/core';


@Component({
  selector: 'logo',
  templateUrl: 'logo.html'
})
export class Logo {

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/logo/logo.ts